module.exports = __webpack_public_path__ + "6d9292c367da63112daed62336e9ad4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/AccessPlace - Search - Desktop.png
// module id = 1039
// module chunks = 0